import axios, { AxiosResponse } from 'axios';

export const whitelabel = {
  getAppConfig: (): Promise<AxiosResponse> => axios.get('/Account/AppConfig'),
};
